import { render, staticRenderFns } from "./Ordenes.vue?vue&type=template&id=e806e2d4&scoped=true&"
import script from "./Ordenes.vue?vue&type=script&lang=js&"
export * from "./Ordenes.vue?vue&type=script&lang=js&"
import style0 from "./Ordenes.vue?vue&type=style&index=0&id=e806e2d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e806e2d4",
  null
  
)

export default component.exports